import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import './Login.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import icons for eye visibility
import apiClient from '../../axios';
import Assets from '../../Assets/Assets';

function Login({ submitted, setSubmitted }) {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [errors, setErrors] = useState({});
    const [passwordVisible, setPasswordVisible] = useState(false); // State for password visibility
    const [loading, setLoading] = useState(false); // State for loader

    const validate = () => {
        let isValid = true;
        const newErrors = {};

        // Email validation
        if (!formData.email) {
            newErrors.email = 'Email is required';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
            isValid = false;
        }

        // Password validation
        if (!formData.password) {
            newErrors.password = 'Password is required';
            isValid = false;
        } else if (formData.password.length < 6) {
            newErrors.password = 'Password must be at least 6 characters';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate the form data first
        if (validate()) {
            setLoading(true); // Show loader
            setErrors({}); // Clear previous errors
            // Prepare the payload for the API call
            const payload = {
                email: formData?.email,
                password: formData?.password,
            };

            // Perform the API call using Axios
            apiClient.post('/login', payload, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const result = response.data; // Axios automatically parses JSON
                    console.log(result);

                    if (result.status === 200) {
                        setSubmitted(true);
                        // Store the token in sessionStorage
                        sessionStorage.setItem('Token', result?.data?.authToken);
                        console.log('Login successful');
                    } else {
                        setSubmitted(false);
                        setErrors((prev) => ({ ...prev, apiError: result.message || 'Login failed' }));
                    }
                })
                .catch((error) => {
                    setSubmitted(false);
                    if (error.response) {
                        // Server responded with a status other than 2xx
                        setErrors((prev) => ({
                            ...prev,
                            apiError: error.response.data?.message || 'An error occurred while logging in',
                        }));
                    } else {
                        // Other errors (network issues, etc.)
                        setErrors((prev) => ({
                            ...prev,
                            apiError: 'Unable to connect to the server. Please try again later.',
                        }));
                    }
                })
                .finally(() => {
                    setLoading(false); // Hide loader
                });
        } else {
            setSubmitted(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    return (
        <div className="login">

            <div className="infologin p-4" >
                <img src={Assets?.Logo} style={{ width: "150px" }}></img>
                <br />
                <br />
                <h3 className="text-center">Login</h3>
                {submitted && <div className="alert alert-success">Login successful!</div>}
                {errors.apiError && <div className="alert alert-danger">{errors.apiError}</div>}
                <form>
                    <div className="mb-3">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        {errors.email && <div className="invalid-feedback" style={{ display: "block", textAlign: "start" }}>{errors.email}</div>}
                    </div>
                    <div className="mb-3 position-relative">
                        <label htmlFor="password">Password</label>
                        <input
                            type={passwordVisible ? "text" : "password"}
                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={togglePasswordVisibility}
                            style={{
                                position: 'absolute',
                                top: '20px',
                                right: '0px',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                            }}
                        >
                            {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                        </button>
                        {errors.password && <div className="invalid-feedback" style={{ display: "block", textAlign: "start" }}>{errors.password}</div>}
                    </div>
                    <button type="submit" className="btn btn-primary w-100" onClick={handleSubmit}>
                        {loading ? (
                            <div className="spinner-border spinner-border-sm text-light" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        ) : (
                            'Login'
                        )}
                    </button>
                </form>
                <div className="mt-3 text-center">
                    <p>
                        <Link to="/forgot-password">Forgot Password?</Link>
                    </p>
                    <p>
                        Don't have an account? <Link to="/signup">Sign Up</Link>
                    </p>
                </div>
            </div>

        </div>
    );
}

export default Login;
